import React, { useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import VideoComponent from './videoPlayer';

// image tiles
import siteState1 from '../img/alpha_academy/site-state-1.jpg'
import siteState1LQ from '../img/alpha_academy/site-state-1-lq.jpg'
import siteState2 from '../img/alpha_academy/site-state-2.jpg'
import siteState2LQ from '../img/alpha_academy/site-state-2-lq.jpg'
import siteState3 from '../img/alpha_academy/site-state-3.jpg'
import siteState3LQ from '../img/alpha_academy/site-state-3-lq.jpg'
import siteState4 from '../img/alpha_academy/site-state-4.jpg'
import siteState4LQ from '../img/alpha_academy/site-state-4-lq.jpg'

import ShopHeader from '../img/alpha_academy/ae-shop-header.jpg'
import ShopHeaderLQ from '../img/alpha_academy/ae-shop-header-lq.jpg'

import smartContract from '../img/alpha_academy/ae-smartcontract-tile.jpg'
import smartContractLQ from '../img/alpha_academy/ae-smartcontract-tile-lq.jpg'

import showAndTell from '../videos/show_and_tell.mp4'
import arcadeBot from '../videos/arcade_game.mp4'

export default function AlphaWebsite() {

    const [ bannerIndex, setBannerIndex ] = useState(0);
    
    const bannerImages = [siteState1, siteState2, siteState3, siteState4];
    const bannerImagesLQ = [siteState1LQ, siteState2LQ, siteState3LQ, siteState4LQ];
    const bannerImagesKey = ["banner-state-1", "banner-state-2", "banner-state-3", "banner-state-4"];

    useEffect(() => {
        window.scrollTo(0,0)
    }, [])

    useEffect(() => {
        const intervalId = setInterval(() => {
          setBannerIndex((prevIndex) => {
            return prevIndex === 2 ? 0 : prevIndex + 1;
          });
        }, 3000);
    
        // Clear interval on component unmount
        return () => {
          clearInterval(intervalId);
        };
      }, []); 

    const pageTransition = {
        initial: {opacity: 0, x: 50},
        animate: {opacity: 1, x: 0},
        exit: {opacity: 0, x: 50}
    }

    const containerVariants = {
        initial: { opacity: 0 },
        animate: {
          opacity: 1,
          transition: {
            delayChildren: 0.5, // delay before child animations start
            staggerChildren: 0.3 // time between each child animation
          }
        },
        exit: { opacity: 0 },
      };

    const deconstructedBackground = {
        initial: {opacity: 0, y: 0},
        animate: {opacity: 1, y: 0, transition: {duration: 0.5}},
        exit: {opacity: 0, y: 0}
    }

    const deconstructedAlpha = {
        initial: {opacity: 0, y: -460},
        animate: (custom) => ({opacity: 1, y: -40 * custom, transition: {duration: 0.7}}),
        exit: {opacity: 0, y: 0}
    }


    return (<>
        <motion.div key="portfolio_page" className='min-h-screen flex flex-col lg:px-0 pt-20' variants={pageTransition} initial="initial" animate="animate" exit="exit">
            <div className='flex flex-col w-full text-center px-4 lg:px-8 bg-almostBlack pt-16 lg:space-y-0 '>
                    <h1 className='pb-0'>Alpha Academy Website</h1>
                    <h3 className='pb-16 font-light'>Alpha Academy</h3>
                <div className='w-full lg:w-4/6 2xl:w-2/4 lg:mt-[10vh] mx-auto'>
                    <div id="alphaacademy" className='text-center lg:text-left pb-16 px-4'>
                        
                        {/* Hero Image */}
                        <LazyLoadImage src={bannerImages[bannerIndex]} placeholderSrc={bannerImagesLQ[bannerIndex]} className='w-full mb-8 lg:mb-16 scale-[1.15] lg:scale-100' alt="artwork collection" />

                        <aside className='text-center lg:text-left w-full mx-auto mb-16 2xl:w-3/4'>
                                <p className='text-mobile leading-5 lg:leading-5 md:text-average mt-6 font-semibold'>Key responsibilities:</p>
                                <ul className='text-mobile leading-5 lg:leading-5 lg:list-disc list-outside ml-6 mt-3 font-light grid grid-cols-1 lg:grid-cols-3 gap-1.5 lg:gap-3'>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>📝</span> Site map, IA & wireframing</li>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>🏗</span> Front-end development</li>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>🛠</span> Back-end development</li>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>🥞</span> Fauna DB integration</li>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>🚧</span> Testing and maintenance</li>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>⚙️</span> Configuring and deploying AWS Lambda functions and S3 file storage</li>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>⛓</span> Integration of smart contract ABIs and content gating via Ethers.js</li>
                                    <li className='col-span-1 pr-3'><span className='-ml-6'>🛒</span> Shopify Hydrogen ecommerce page with Coinbase integration</li>
                                </ul>
                                <p className='text-mobile leading-5 lg:leading-7 md:text-average mt-8 font-semibold'>Tech stack:</p>
                                <p className='text-mobile leading-5 lg:leading-7'>React.js & Ethers.js (blockchain interactions), FaunaDB, Apollo GraphQL, Tailwind CSS, Framer Motion, AWS S3 and AWS Lambda</p>
                        </aside>

                        <p className='w-full 2xl:w-3/4 mx-auto para text-mobile leading-6 lg:leading-7 lg:text-large font-semibold'>
                            The Alpha Academy website was designed to be a bold platform to introduce prospective customers to our universe, offering the optimal way to explore our collection through our gallery and offer exclusive rewards to members via a members-only section.
                        </p>
                        <p className='w-full 2xl:w-3/4 mx-auto para text-mobile leading-6 lg:leading-7 lg:text-large'>
                            A standout advantage of blockchain technology is decentralisation and demonstrable ownership. Utilising Ethers.js, a web3 JavaScript library, I devised a user authentication system that instantly verified and authenticated any artwork owner, unlocking additional site areas without the need for our server to store personal data.
                            
                            <a href="https://alphaacademy.app/" target='_blank' alt="Visit the Alpha Academy Website" title="Visit the website" className='btn-secondary mt-8 transition-colors group-hover:bg-accent mx-auto hover:cursor-pointer' >Visit Alpha Academy</a>
                        </p>
                    </div>
                </div>
            </div>

            {/* SHOW AND TELL */}
            <div className='flex flex-col w-full text-center px-4 lg:px-8 bg-almostBlack pt-24 pb-10 lg:space-y-0 '>
                <div className='w-full lg:w-4/6 2xl:w-2/4 mx-auto text-center lg:text-left'>
                    <h3 className='mb-4'>Show &amp; Tell Interactive Comic</h3>
                        <VideoComponent source={showAndTell} autoplay={false} loop={false} className="pb-10 pt-2 lg:pt-8 scale-100" />
                    <p className='w-full 2xl:w-3/4 mx-auto para text-mobile leading-6 lg:leading-7 lg:text-large'>
                        Building on our initial artwork launch—Alpha Elementary, we introduced a follow-up collection, presented as a gift to anyone owning one of our artworks. This collection, comprised of custom artworks illustrated by our artist, was revealed through an interactive comic on our website. Members received a token depicted as a backpack. Via the interactive comic, they could unveil their surprise artwork on our website, dynamically updating the NFT and metadata, visible across all NFT marketplaces. To facilitate this, I utilised p5.js to craft an interactive comic that accessed a configured AWS Lambda function. The function refreshed stored metadata from various marketplace APIs and updated JSON files in our associated S3 bucket.
                    </p>
                    
                    <div className='flex flex-col 2xl:w-3/4 lg:flex-row mt-16 lg:space-x-16 mx-auto'>
                        <p className='w-full mx-auto para text-mobile leading-6 lg:leading-7 lg:text-large'>
                        To take things further, I experimented by hiding an entire game of Snake inside an NFT which could be played anywhere NFTs can be viewed.
                        </p>
                        <VideoComponent source={arcadeBot} autoplay={true} loop={true} className="lg:scale-100" />
                    </div>
                </div>
            </div>

            <div className='flex flex-col w-full text-center px-4 lg:px-8 bg-almostBlack pt-24 pb-10 lg:space-y-0 '>
                <div className='w-full lg:w-4/6 2xl:w-2/4 mx-auto text-center lg:text-left'>

                        <h3 className='mb-4'>Ecommerce Integration</h3>
                        <LazyLoadImage src={ShopHeader} placeholderSrc={ShopHeaderLQ} className='w-full mt-4 mb-8 lg:mb-16 scale-[1.05] lg:scale-100' alt="artwork collection" />
                        <p className='w-full 2xl:w-3/4 mx-auto para text-mobile leading-6 lg:leading-7 lg:text-large'>
                            For our limited merch drop, a standard Shopify store wasn't adequate. Instead, I leveraged Shopify's new React-based Hydrogen headless commerce framework to deliver a highly branded shopping experience that didn't feel like just another online store. I also incorporated Coinbase's payment solution for blockchain-based crypto payments to cater more effectively to our audience.
                        </p>
                        <p className='w-full 2xl:w-3/4 mx-auto para text-mobile leading-6 lg:leading-7 lg:text-large'>
                        Smart contracts deployed to the Ethereum blockchain-based enabled us to build art art collections that provided a transparent and decentralised ownership. The Alpha Academy website gave the contracts I deployed a user interface and personality. Read more about the smart contracts deployed below.
                        </p>
                </div>

                <motion.div initial={{opacity: 0, y: 30}} whileInView={{opacity: 1, y: 0, transition: {delay: 0.5}}} viewport={{once: true, margin: "-100px 0px 0px 0px"}} key="upnext"
                className='w-3/4 lg:w-1/4 2xl:w-1/6 mx-auto text-center snap-center hover:cursor-pointer group flex flex-col lg:place-content-between py-20'>
                    <h3 className='mt-6 mb-4'>View next 👇</h3>
                    <Link to="/smart-contracts" title="View the project" className=''>
                        <LazyLoadImage src={smartContract} placeholderSrc={smartContractLQ} className='w-full' alt="artwork collection" />
                        <div className='flex flex-col'>
                        <h3 className='mt-10 mb-4'>Smart Contracts</h3>
                            <p className='text-mobile'>
                                ERC-721 smart contracts deployed on the Ethereum network to facilitate trustless, decentralised acquisition, transfer and querying of our art collection.
                            </p>
                            <div className='btn-secondary mt-8 transition-colors group-hover:bg-accent mx-auto' title="View the project">
                                View Project
                            </div>
                        </div>
                    </Link>
                </motion.div>
            </div>

        </motion.div >
    </>);
}